module.exports = __webpack_public_path__ + "static/media/banner_2.4ef2b1ff.webp";